import React, { ReactNode } from 'react';
import Icon from '../../../../../muiComponents/Icon';

export interface ModeSelectorOption<T> {
    value: T;
    iconName: string;
    label?: ReactNode;
}

interface ModeSelectorProps<T> {
    options: ModeSelectorOption<T>[];
    selectedValue: T;
    onChange: (value: T) => void;
}

const ModeSelector = <T,>({
    options,
    selectedValue,
    onChange,
}: ModeSelectorProps<T>) => {
    return (
        <div className='services-view-mode-selector__container'>
            {options.map(option => (
                <button
                    key={String(option.value)}
                    type='button'
                    className={`services-view-mode-selector__button ${
                        selectedValue === option.value ? '--active' : ''
                    }`}
                    onClick={() => onChange(option.value)}
                >
                    <Icon iconName={option.iconName} />
                    {option.label}
                </button>
            ))}
        </div>
    );
};

export default ModeSelector;
